<template>
    <!--  -->
     <div class="modal fade" id="createaddstoreModal" tabindex="-1" aria-labelledby="createaddstoreModalLabel" aria-hidden="true">
         <div class="modal-dialog">
           <div class="modal-content">
             <div class="modal-header">
               <h5 class="modal-title" id="createaddstoreModalLabel">Add Store</h5>
               <button type="button"  data-bs-dismiss="modal" aria-label="Close">X</button>
             </div>
             <div class="modal-body">
                 <form>
                     <div class="form-group">
                         <label for="exampleInputEmail1">Store Name</label>
                         <input name="store_name" v-on:keyup="handleKeyUp" type="text" class="form-control" placeholder="Enter store name">
                         <small id="emailHelp" class="form-text text-muted">This is creates a new item location</small>
                     </div>
                    
                   
                     <button @click="submitHandler" class="btn btn-primary righter">Submit</button>
                 </form>
             </div>
             
           </div>
         </div>
       </div>
          <!--  -->
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";


export default {
 name:"createstoremodal",
 data() {
 return {
   store_name:"",
 };
},
methods:{
 async submitHandler(){
     try {
     this.apiLoading = true;
       const url = 'inventory/createStore'; 
       const body = { store_name: this.class_name};

       const rs = await generalApiRequest(url, 'POST', body, 1);
      console.log(rs);
   } catch (error) {
      console.error('Error fetching data:', error);
   }
 },
 onchangeHandler(e){
     console.log(e.target.value);
     
 },
 handleKeyUp(e){
     console.log(e.target.value);
     this.class_name = e.target.value;
 }

},
}
</script>

<style>

</style>